import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClinicResources,
  createResource,
  updateResource,
  deleteResource,
} from "../thunks/resourceThunk";

const initialState = {
  resources: [],
  status: "idle",
  error: null,
  selectedResource: null,
};

const resourceSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    setSelectedResource: (state, action) => {
      state.selectedResource = action.payload;
    },
    clearSelectedResource: (state) => {
      state.selectedResource = null;
    },
    clearResourceErrors: (state) => {
      state.error = null;
      state.bookingError = null;
    },
    clearBookingStatus: (state) => {
      state.bookingStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch resources
      .addCase(fetchClinicResources.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchClinicResources.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.resources = action.payload;
        state.error = null;
      })
      .addCase(fetchClinicResources.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Create resource
      .addCase(createResource.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createResource.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.resources.push(action.payload);
        state.error = null;
      })
      .addCase(createResource.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Update resource
      .addCase(updateResource.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateResource.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.resources.findIndex(
          (resource) => resource._id === action.payload._id
        );
        if (index !== -1) {
          state.resources[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateResource.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Delete resource
      .addCase(deleteResource.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteResource.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.resources = state.resources.filter(
          (resource) => resource._id !== action.payload
        );
        state.error = null;
      })
      .addCase(deleteResource.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const {
  setSelectedResource,
  clearSelectedResource,
  clearResourceErrors,
} = resourceSlice.actions;

export default resourceSlice.reducer;
